import dayjs from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);
dayjs.extend(timezone);

export const TZ = "Asia/Tashkent";

export function formatDateTime(date: string | undefined | null): string {
	if (!date) {
		return "—";
	}
	return dayjs.utc(date).tz(TZ).format("DD.MM.YYYY HH:mm:ss");
}

export function formatTime(date: string | undefined | null): string {
	if (!date) {
		return "—";
	}
	return dayjs.utc(date).tz(TZ).format("HH:mm:ss");
}

export function formatDurationFromDates(start: string, end: string): string {
	const diff = Math.floor((dayjs.utc(end).valueOf() - dayjs.utc(start).valueOf()) / 1000);
	const h = Math.floor(diff / 3600);
	const m = Math.floor((diff % 3600) / 60);
	if (h > 0) {
		return `${h}h ${m}m`;
	}
	return `${m} daqiqa`;
}
